import React, {useEffect, ReactNode, useState} from "react";
import "./Banner.css";
import Close from "@mui/icons-material/Close";


export const Banner = ({variant, children}) => {
    const [dismiss, setDismiss] = useState(false);
    if (dismiss) {
        return null;
    }
    return <div className={`banner ${variant}`}>
        <Close className={"close-icon"} onClick={() => setDismiss(true)}/>
        {children}
    </div>
};


export default Banner;
